import AsyncBlockService from 'services/async-block-service';
var BlockView = require('views/block/base-block-view');
var LocaleService = require('services/locale-service');
const eSignatureTemplate = require('views/block/resource/templates/e-signature');
var ContentProvider = require('services/content-provider');

var ResourceView = BlockView.extend({
  load: function() {

    Handlebars.registerPartial('e-signature', eSignatureTemplate);

    this.registerRegion(`resources-${this.model.get('cid')}`, `.resources-${this.model.get('cid')}`);
    var self = this;

    if(this.model.get('resource_type') === undefined && this.model.get('resource_sub_type') === undefined) {
      EF.resources.fetch().then(function() {
        self.bindView(EF.resources);
      });
    } else {
      ContentProvider.ResourceService.getResources(this.model.get('resource_type'), this.model.get('resource_sub_type')).then(function(resources) {
        self.bindView(new Chaplin.Collection(resources));
      });
    }
  },
  bindView: function(collection) {
    var self = this;
    self.collection = collection;
    AsyncBlockService.load([ 'resource' ], [ 'views/block/resource/resource-collection-view' ]).then(([ ResourceCollectionView ]) => {
      var resourceCollectionView = new ResourceCollectionView({
        collection: self.collection,
        region: `resources-${this.model.get('cid')}`,
        model: self.model
      });
      self.subview('resources', resourceCollectionView);
      self.$('.marked-down a').attr('target', '_blank');
      const resourceItems = self.collection.models;
      self.collection.on('change:signature_confirmed', function() {
        _.bind(self.checkComplete, self);
        if(self.model) {
          var signedCaption = self.model.get('e_sign_caption_signed');
          if( signedCaption ) {
            signedCaption = LocaleService.t(signedCaption);
            resourceItems.forEach(item => {
              const resourceId = item.get('id');
              $(`label[for="e-sign-resource-${resourceId}"] .e-sign-label`).text(signedCaption);
            });
          }
        }
        if(self.collection) {
          self.collection.on('change:link_clicked', _.bind(self.checkComplete, self));
          self.collection.on('change:body_viewed', _.bind(self.checkComplete, self));
          if(self.model.get('state') === 'playing') {
            self.checkComplete();
          }
          Chaplin.mediator.publish('block:resources:rendered', self.collection);
        }
      });
    });
  },
  play: function() {
    if(this.collection) {
      this.checkComplete();
    }
  },
  checkComplete: function() {
    if(this.model && this.model.get('resource_type') === 'PolicyResource' && this.collection) {
      var eSigComplete = _.every(this.collection.filter({requires_e_signature: true}), (r) => r.get('signed'));
      var linkClickComplete = _.every(this.collection.filter({requires_e_signature: false, requires_link_click: true}), (r) => r.get('link_clicked'));
      var bodyViewComplete = _.every(this.collection.filter({requires_body_view: true}), (r) => r.get('body_viewed'));
      if(eSigComplete && linkClickComplete && bodyViewComplete) {
        this.readyToGo();
      }
    } else {
      this.readyToGo();
    }
  }
});

module.exports = ResourceView;
